import { useEffect, useState, useRef } from 'react'

type AnimatedBackgroundProps = {
  blurAmount: number
}

export function AnimatedBackground({ blurAmount }: AnimatedBackgroundProps) {
  const [scale, setScale] = useState(0)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const breathe = () => {
      setScale(prev => (prev + 0.005) % 1)
    }

    const intervalId = setInterval(breathe, 50)
    return () => clearInterval(intervalId)
  }, [])

  const size = 50 + (50 * Math.sin(scale * Math.PI))  // Varies between 50% and 100%

  return (
    <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none" ref={containerRef}>
      <div 
        className="absolute inset-0 transition-all duration-1000 ease-in-out"
        style={{
          clipPath: `circle(${size}% at top right)`,
        }}
      >
        <div className="absolute inset-0 animate-gradient-1" />
        <div className="absolute inset-0 animate-gradient-2" />
        <div className="absolute inset-0 animate-gradient-3" />
      </div>
      <div 
        className="absolute inset-0 transition-all duration-300 ease-in-out"
        style={{
          backdropFilter: `blur(${blurAmount}px)`,
          WebkitBackdropFilter: `blur(${blurAmount}px)`,
          maskImage: `radial-gradient(circle ${size}% at top right, black, transparent)`,
          WebkitMaskImage: `radial-gradient(circle ${size}% at top right, black, transparent)`,
          maskSize: '200% 200%',
          WebkitMaskSize: '200% 200%',
          maskPosition: 'top right',
          WebkitMaskPosition: 'top right',
        }}
      />
    </div>
  )
} 